const mediaItems = [
  {
    type: 'image',
    src: 'https://public.readdy.ai/ai/img_res/2c72e87fcaca968c7c8521a0371fafad.jpg',
    label: 'Conference Atmosphere',
  },
  {
    type: 'video',
    src: 'https://readdy.ai/api/search-image?query=young%20Christian%20worship%20band%20on%20stage%20dark%20background%20golden%20stage%20lights%20guitarist%20vocalist%20drummer%20powerful%20revival%20concert%20atmosphere%20cinematic%20dramatic&width=600&height=400&seq=media02&orientation=landscape',
    label: 'Worship Highlights',
  },
  {
    type: 'image',
    src: 'https://readdy.ai/api/search-image?query=dramatic%20cinematic%20youth%20prayer%20gathering%20crowd%20bowing%20in%20prayer%20dark%20room%20golden%20light%20rays%20from%20above%20atmospheric%20fog%20revival%20meeting%20spiritual%20powerful&width=600&height=400&seq=media03&orientation=landscape',
    label: 'Prayer & Encounter',
  },
  {
    type: 'reel',
    src: 'https://readdy.ai/api/search-image?query=young%20people%20creative%20drama%20skit%20on%20stage%20dark%20cinematic%20dramatic%20colored%20spotlights%20Christian%20youth%20conference%20creative%20arts%20ministry%20powerful&width=600&height=400&seq=media04&orientation=landscape',
    label: 'Creative Ministry Skits',
  },
  {
    type: 'image',
    src: 'https://readdy.ai/api/search-image?query=beautiful%20dark%20revival%20conference%20stage%20setup%20with%20stunning%20golden%20and%20warm%20lighting%20elegant%20minimal%20stage%20design%20youth%20Christian%20conference&width=600&height=400&seq=media05&orientation=landscape',
    label: 'Stage Setup',
  },
  {
    type: 'video',
    src: 'https://readdy.ai/api/search-image?query=close%20up%20of%20young%20person%20raising%20hands%20in%20worship%20dark%20atmospheric%20background%20golden%20bokeh%20lights%20tears%20joy%20surrender%20spiritual%20revival%20encounter%20cinematic&width=600&height=400&seq=media06&orientation=landscape',
    label: 'Worship Moments',
  },
];

const typeColors: Record<string, string> = {
  image: '#888',
  video: '#D4A842',
  reel: '#F0C040',
};

const typeIcons: Record<string, string> = {
  image: 'ri-image-line',
  video: 'ri-play-circle-line',
  reel: 'ri-vidicon-line',
};

const MediaHighlights = () => {
  return (
    <section
      id="media"
      className="relative py-24 px-6 overflow-hidden"
      style={{ background: 'linear-gradient(180deg, #0a0a0a 0%, #0d0d0d 100%)' }}
    >
      <div
        className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-px pointer-events-none"
        style={{ background: 'linear-gradient(90deg, transparent, rgba(212,168,66,0.3), transparent)' }}
      />

      <div className="max-w-3xl mx-auto relative z-10">
        <div className="text-center mb-14">
          <div
            className="inline-block mb-5 px-4 py-1 rounded-full text-xs font-semibold tracking-widest uppercase"
            style={{ background: 'rgba(212,168,66,0.1)', border: '1px solid rgba(212,168,66,0.3)', color: '#D4A842', fontFamily: "'Glacial Indifference', sans-serif" }}
          >
            Gallery &amp; Media
          </div>
          <h2
            className="text-3xl md:text-4xl font-black uppercase mb-3"
            style={{ fontFamily: "'Glacial Indifference', sans-serif", color: '#FFFFFF' }}
          >
            Highlights
          </h2>
          <p className="text-gray-400 text-sm max-w-sm mx-auto" style={{ fontFamily: "'Glacial Indifference', sans-serif" }}>
            Posters, worship reels, teaser videos, and moments from the movement.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          {mediaItems.map((item) => (
            <div
              key={item.label}
              className="relative rounded-xl overflow-hidden cursor-pointer group"
              style={{ border: '1px solid rgba(212,168,66,0.15)', aspectRatio: '3/2' }}
            >
              <img
                src={item.src}
                alt={item.label}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0" style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.75) 0%, transparent 50%)' }} />
              <div className="absolute bottom-2 left-2 right-2 flex items-center justify-between">
                <span className="text-xs text-white font-medium truncate mr-2" style={{ fontFamily: "'Glacial Indifference', sans-serif" }}>
                  {item.label}
                </span>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`${typeIcons[item.type]} text-sm`}
                    style={{ color: typeColors[item.type] }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        <p className="text-center text-xs text-gray-600 mt-6" style={{ fontFamily: "'Glacial Indifference', sans-serif" }}>
          More highlights and teaser reels coming soon. Stay connected on social media.
        </p>
      </div>
    </section>
  );
};

export default MediaHighlights;
